<template>
  <div class="home">
    <!-- 初心模块 -->
    <div class="hope">
      <div class="dream">
        <p class="original">初心</p>
        <i class="circle"></i>
        <p class="carry">怀揣梦想</p>
      </div>
      <div class="wave">跻身互联网创业浪潮</div>
      <div class="most">
        <p>
          和绝大多数创业者一样，鲲鹏创信的创始团队创业初衷为了让家人和自己过上有品质的生活，作为深耕招投标工作十余年的创业成员，深知团队协作与沟通的痛点，抱着解决人与人之间协作、初创团队寻找资金、场地困难等问题，鲲鹏创信团队开始了他们的创业。
        </p>
      </div>
    </div>

    <div class="start">
      <img
        class="opportunity"
        src="../../assets/images/start.png"
        alt="start"
      />
      <img class="back" src="../../assets/images/back.png" alt="back" />
      <div class="chance">这个时代赋予了我们很多机会</div>
      <div class="only">
        也只有 <span>互联网</span> 给我们提供了一个变道超车的机会
      </div>
    </div>

    <!-- 同心模块 -->
    <div class="hope">
      <div class="concentric">
        <p class="original">同心</p>
        <i class="circle"></i>
        <p class="carry">全力奋进</p>
      </div>
      <div class="partner">找到一群理想的工作伙伴</div>
      <div class="most">
        <p>
          在错综复杂且风云巨变的互联网市场中，个人创业时代已经过去，创业须学会抱团取暖，借力使力，利用各种可用的资源，让企业快速成长起来。很多大佬表示如今的创业卖的是产品服务，长久而言拼的却是团队成员。
        </p>
      </div>
    </div>
    <!-- 人物头像模块 -->
    <div class="people">
      <img
        class="handshake"
        src="../../assets/images/handshake.png"
        alt="handshake"
      />
      <div class="circle1"></div>
      <div class="circle2"></div>
      <div class="circle3"></div>
      <div class="circle4"></div>
      <div class="celebrity">
        <div class="bigLiu">
          <div class="img">
            <img src="../../assets/images/liu.jpg" alt="" />
          </div>
          <p class="bigLiuName">刘强东</p>
          <p class="jd">京东创始人</p>
          <p class="success">
            创业成功需要具备四个要素：团队、用户体验、成本和效率
          </p>
        </div>
        <div class="bigLiu">
          <div class="img">
            <img src="../../assets/images/lei.jpg" alt="" />
          </div>
          <p class="bigLiuName">雷军</p>
          <p class="jd">小米创始人</p>
          <p class="success">
            创业时找到了好的团队就成功了一半。小米智能手机成功之道在于有好的创业团队、创新及好口碑。
          </p>
        </div>
        <div class="bigLiu">
          <div class="img">
            <img src="../../assets/images/wang.jpg" alt="" />
          </div>
          <p class="bigLiuName">王兴</p>
          <p class="jd">美团创始人</p>
          <p class="success">
            好的团队标准是合而不同，团队的技能、观点不必完全一致
            但能和谐地为一个目标而发力。
          </p>
        </div>
      </div>
      <div class="see">
        <p class="seeThat">由此可见，</p>
        <p class="team">
          创业团队才是创业的主要内核。组成一个创业团队，创业也就成功了一半。
        </p>
        <p class="process">
          鲲鹏创信从开始的崇拜技术的比拼，到服务的较量，再到团队间的精诚合作，一路成长，一路蜕变。在这里，通过现有的业务来培养人，然后通过团队来扩展新的模式和疆土，只要每一个人将自己擅长的事做到极致，把公司的价值发挥到最大化，都能称之为公司的超级英雄。
        </p>
      </div>
    </div>
    <!-- 炼心模块 -->
    <div class="heart">
      <div class="dream">
        <p class="original">炼心</p>
        <i class="circle"></i>
        <p class="carry">所谓创业</p>
      </div>
      <div class="wave">就是在“半空中造飞机”</div>
      <div class="most">
        <p>
          在初创公司，战略统一，但战术改变是不可避免的。实际上，许多人根本无法忍受频繁的变化。
        </p>
      </div>
    </div>
    <!-- 愿景模块 -->

    <div class="vision">
      <p class="us">我们的愿景</p>
      <div class="first">
        <p>第一，我们要建立一家生存100年的公司</p>
        <p>第二，我们要成为致力于提高人与人协作效率的互联网公司</p>
        <p>
          第三，我们要努力成为世界级互联网公司，帮助更多人升级生活与工作的新模式
        </p>
      </div>
      <div class="future">
        未来的目标很远大、很鼓舞人，但在实现梦想的道路上必定困难重重。鲲鹏创信创业至今也遇到过无数的困难：人才流失、回款困难等问题，但最终都被解决。<br />
        就这样，遭遇一个个难关，又解决一个个问题，就这样不断夯实了团队的凝聚力和归属感，也就成就了今日的鲲鹏创信。
      </div>
    </div>
    <div class="story">
      <p class="eagle">鲲鹏创信团队坚信的故事</p>
      <p class="eagleStory">
        老鹰活到四十岁身体开始老化，它必须经历拔掉老旧飞羽、拍掉长啄等五个月的困苦淬炼，方能焕然新生，便可再翱翔天际三十年。<br />
        很多商界大佬都曾经强调过，自己的成功离不开当初种种失败的经历。所以我们创业者每一个曾经失败的局，对于我们未来创业都具有非常重大的意义。
      </p>
    </div>
    <div class="reflection">
      <div class="kids"></div>
      <div class="think">与创业者共同思考?</div>
      <div class="solve">
        <p class="solveQuestion">鲲鹏创信团队要解决哪些问题？</p>
      </div>
      <div class="choice">
        <p>
          A、解决有梦想的个人和创业团队面临的资金困难、缺少资源、缺乏人才的问题。
        </p>
        <p>B、更好的解决企业开发产品的问题，优化服务内容。</p>
      </div>
      <div class="existence">
        <div class="development">
          <p class="before">先生存，后发展</p>
          <p>
            仰望星空的同时，也要脚踏实地。为了今后更好的发展，目前也会接外包订单。一是为公司存活负责，更是为员工负责。在这个工作中，我们也将帮助更多的企业实现他们的梦想，而通过各个行业项目的复盘、拆解、分析、总结出来的经验，也是无法用金钱衡量。
          </p>
        </div>
        <div class="development topValue">
          <p class="before">拥抱变化</p>
          <p>
            互联网最大的特点就是高速迭代发展，稍不留神，就有可能落后于同行。公司只有不断变化，在保持整体战略框架下，根据实际情况调整战术，才能把握更好的方向。
          </p>
        </div>
        <div class="development">
          <p class="before">边界扩展</p>
          <p>
            未来，我们将围绕解决团队协作的问题的点，进而打通上下游链接成线，最后的目标是形成我们独有的生态系统。当然，这个具体实施计划暂时保密哈~
          </p>
        </div>
        <div class="development">
          <p class="before">发展壮大</p>
          <p>
            我们一直希望保持目前小而精的团队状态，但为了实现今后宏伟的发展目标，势必会引入更多深入实战在一线的互联网从业者、创业者，为提升公司整体的核心竞争力创造更多可能。
          </p>
        </div>
      </div>
      <div class="plan">
        <p>鲲鹏创信团队未来的计划？</p>
      </div>
      <div class="job">
        <p>鲲鹏创信未来工作方式的思考 ？</p>
      </div>
      <div class="society">
        <div class="core">
          <p class="somebody">
            社会越是发达，人的独立性就越强 <br />
            有人认为，线上协同工作，是未来主流的工作方式。 <br />
            线上办公替代传统办公，是否加速启动？<br />
            鲲鹏认为有三个核心思考点：
          </p>
          <p>
            1、怎么招聘团队成员？ <br />2、如何做KPI，评价工作绩效？
            <br />3、如何协作管理？
          </p>
        </div>
      </div>
      <div class="compose">
        <p>
          文档撰写？<br />
          考勤管理？<br />
          视频会议？<br />
          行业知识整合？
        </p>
      </div>
      <div class="platform">
        <p>多元化平台会有哪些机会？</p>
      </div>
    </div>
    <div class="answer">
      <div>一个好问题远比答案重要</div>
      <p>如果你对未来有更多的思考</p>
      <p>那么请带上你的好奇心</p>
      <p>与我们深度协同，探索无限可能</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang='less' scoped>
.home {
  width: 100%;
  .hope {
    margin-left: 15rem;
    width: 90rem;
    height: 38.0625rem;
    .dream {
      margin-top: 8.1875rem;
      margin-bottom: 4.875rem;
      display: flex;
      justify-content: left;
      width: 90rem;
      height: 5rem;
      line-height: 5rem;
      text-align: center;
      .original {
        font-size: 60px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .circle {
        margin: 2.5rem 1.5625rem;
        width: 0.5rem;
        height: 0.5rem;
        background-color: #333333;
        border: 0.0625rem solid #333333;
        border-radius: 50%;
      }
      .carry {
        margin-left: 1.0625rem;
        font-size: 50px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #1e7fb2;
      }
    }
    .concentric {
      margin-top: 8.1875rem;
      margin-bottom: 4.875rem;
      // margin-right: 15rem;
      display: flex;
      justify-content: right;
      height: 5rem;
      line-height: 5rem;
      text-align: center;
      .original {
        font-size: 60px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .circle {
        margin: 2.5rem 1.5625rem;
        width: 0.5rem;
        height: 0.5rem;
        background-color: #333333;
        border: 0.0625rem solid #333333;
        border-radius: 50%;
      }
      .carry {
        margin-left: 1.0625rem;
        font-size: 50px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #1e7fb2;
      }
    }
    .wave {
      margin-bottom: 4.875rem;
      width: 100%;
      height: 3.25rem;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .partner {
      display: flex;
      justify-content: right;
      margin-bottom: 4.875rem;
      height: 3.25rem;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .most {
      width: 90rem;
      height: 15.0625rem;
      p {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        letter-spacing: 0.125rem;
        color: #333333;
      }
    }
  }
  .start {
    position: relative;
    width: 100%;
    height: 41.5625rem;
    .opportunity {
      width: 100%;
      height: 41.5625rem;
    }
    .back {
      position: absolute;
      top: 10.875rem;
      left: 21.25rem;
      width: 81.4375rem;
      height: 24.5625rem;
    }
    .chance {
      position: absolute;
      top: 13.75rem;
      left: 38.8125rem;
      width: 42.5rem;
      height: 4.125rem;
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 2px;
    }
    .only {
      position: absolute;
      top: 24.1875rem;
      left: 25.6875rem;
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 2px;
      span {
        color: #1e7fb2;
        font-size: 3.75rem;
      }
    }
  }
  .people {
    position: relative;
    width: 100%;
    height: 74.8125rem;
    .handshake {
      width: 100%;
      height: 74.8125rem;
    }
    .celebrity {
      position: absolute;
      top: 2.625rem;
      left: 14.625rem;
      display: flex;
      justify-content: space-around;
      width: 90rem;
      height: 37.5rem;

      div {
        padding: 0 1.5rem;
        width: 29.375rem;
        height: 37.5rem;
        background: #ffffff;
        box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
        border-radius: 6px;
      }
      div:hover {
        border: #1e7fb2 1px solid;
      }
      .bigLiu {
        margin: 0 0.625rem;
        display: flex;
        // justify-content: center;
        align-items: center;
        flex-direction: column;
        .img {
          padding: 0;
          margin-top: 3.25rem;
          margin-bottom: 1.375rem;
          width: 8.125rem;
          height: 8.125rem;
          border-radius: 50%;

          img {
            width: 8.125rem;
            height: 8.125rem;
            border: 0.0625rem #1e7fb2 solid;
            border-radius: 50%;
          }
        }
        .bigLiuName {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          letter-spacing: 2px;
          opacity: 1;
          margin-bottom: 1.0625rem;
        }
        .jd {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-bottom: 2rem;
        }
        .success {
          text-align: left;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 61px;
          color: #333333;
        }
      }
    }
    .see {
      position: absolute;
      left: 15rem;
      bottom: 2.5625rem;
      width: 90rem;
      height: 27.875rem;
      .seeThat {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 2.75rem;
        z-index: 999;
      }
      .team {
        font-size: 42px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #1e7fb2;
        letter-spacing: 1px;
        margin-bottom: 3.875rem;
      }
      .process {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        letter-spacing: 2px;
      }
    }
    .circle1 {
      position: absolute;
      top: 41.875rem;
      left: 60.625rem;
      width: 2.25rem;
      height: 2.25rem;
      border: 1px solid #c4c4c4;
      border-radius: 50%;
    }
    .circle2 {
      position: absolute;
      top: 44.375rem;
      left: 52.8125rem;
      width: 2.25rem;
      height: 2.25rem;
      border: 1px solid #c4c4c4;
      border-radius: 50%;
    }
    .circle3 {
      position: absolute;
      top: 47.875rem;
      left: 40.25rem;
      width: 2.25rem;
      height: 2.25rem;
      border: 1px solid #c4c4c4;
      border-radius: 50%;
    }
    .circle4 {
      position: absolute;
      top: 49rem;
      left: 28.25rem;
      width: 2.25rem;
      height: 2.25rem;
      border: 1px solid #c4c4c4;
      border-radius: 50%;
    }
  }
  .heart {
    margin-left: 15rem;
    width: 90rem;
    height: 100%;
    .dream {
      margin-top: 8.1875rem;
      margin-bottom: 4.875rem;
      display: flex;
      justify-content: left;
      width: 90rem;
      height: 5rem;
      line-height: 5rem;
      text-align: center;
      .original {
        font-size: 60px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .circle {
        margin: 2.5rem 1.5625rem;
        width: 0.5rem;
        height: 0.5rem;
        background-color: #333333;
        border: 0.0625rem solid #333333;
        border-radius: 50%;
      }
      .carry {
        margin-left: 1.0625rem;
        font-size: 50px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #1e7fb2;
      }
    }
    .wave {
      margin-bottom: 4.875rem;
      width: 100%;
      height: 3.25rem;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .most {
      width: 90rem;
      height: 15.0625rem;
      p {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        letter-spacing: 0.125rem;
        color: #333333;
      }
    }
  }
  .vision {
    display: flex;
    align-items: center;
    flex-direction: column;

    width: 100%;
    height: 56.5625rem;
    background: url(../../assets/images/vision.png);
    background-size: 100% 56.5625rem;
    .us {
      padding: 2rem 1.8125rem;
      margin-top: 3.75rem;
      margin-bottom: 5.375rem;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      border-bottom: 0.125rem solid #ffffff;
    }
    .first {
      width: 79.3125rem;
      height: 19.8125rem;
      padding-top: 2.75rem;
      margin-bottom: 7.625rem;
      background: url(../../assets/images/159.png);
      background-size: 79.3125rem 19.8125rem;
      p {
        padding-left: 4.25rem;
        padding-bottom: 3.375rem;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 2px;
      }
    }
    .future {
      width: 79.3125rem;
      height: 7.4375rem;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 1px;
    }
  }
  .story {
    width: 100%;
    height: 46.6875rem;
    padding-top: 94px;
    background: url(../../assets/images/birds.png);
    background-size: 100% 46.6875rem;
    .eagle {
      width: 575px;
      height: 66px;

      margin-bottom: 109px;
      margin-left: 240px;
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
    .eagleStory {
      width: 996px;
      height: 385px;
      margin-left: 240px;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      letter-spacing: 2px;
      color: #333333;
    }
  }
  .reflection {
    position: relative;
    width: 100%;
    height: 1904px;
    background: rgba(255, 255, 255, 0.39);

    .kids {
      margin-left: 240px;
      width: 266px;
      height: 266px;
      background: url(../../assets/images/77.png);
      background-size: 266px 266px;
    }

    .think {
      position: absolute;
      top: 100px;
      left: 528px;
      width: 444px;
      height: 66px;
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
    .solve {
      position: absolute;
      top: 178px;
      left: 240px;
      width: 484.16px;
      height: 484.16px;
      background: url(../../assets/images/4444.png);
      background-size: 484.16px 484.16px;
      .solveQuestion {
        position: absolute;
        top: 191px;
        left: 171px;
        width: 154px;
        height: 78px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 38px;
        color: #333333;
      }
    }
    .choice {
      position: absolute;
      top: 362px;
      left: 700px;
      width: 831px;
      height: 116px;
      background: rgba(252, 252, 252, 0.39);
      border: 1px solid #1e7fb2;
      border-radius: 57px;
      p {
        padding-left: 40px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 61px;
        color: #333333;
      }
    }
    .existence {
      position: absolute;
      top: 541px;
      left: 272px;
      width: 1068px;
      height: 575px;
      background: rgba(252, 252, 252, 0.39);
      border: 1px solid #1e7fb2;
      border-radius: 57px;
      .development {
        padding: 37px 42px;
        width: 100%;
        height: 122px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 32px;
        color: #333333;
        // letter-spacing: 2px;
        .before {
          font-weight: bold;
        }
      }
      .topValue {
        margin-top: 37px;
      }
    }
    .plan {
      position: absolute;
      top: 555px;
      left: 1253px;
      width: 484.16px;
      height: 484.16px;
      background: url(../../assets/images/7777.png);
      background-size: 484.16px 484.16px;
      p {
        position: absolute;
        top: 191px;
        left: 171px;
        width: 154px;
        height: 78px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 38px;
        color: #333333;
      }
    }
    .job {
      position: absolute;
      top: 1097px;
      left: 240px;
      width: 484.16px;
      height: 484.16px;
      background: url(../../assets/images/4444.png);
      background-size: 484.16px 484.16px;
      p {
        position: absolute;
        top: 191px;
        left: 171px;
        width: 154px;
        height: 78px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 38px;
        color: #333333;
      }
    }
    .society {
      position: absolute;
      top: 1176px;
      left: 700px;
      width: 543px;
      height: 327px;
      padding: 35px 40px;
      background: rgba(252, 252, 252, 0.39);
      border: 1px solid #1e7fb2;
      border-radius: 57px;
      .core {
        width: 463px;
        height: 257px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 32px;
        color: #333333;
        opacity: 1;
        .somebody {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: normal;
          line-height: 32px;
          color: #333333;
          letter-spacing: 2px;
          opacity: 1;
        }
      }
    }
    .compose {
      position: absolute;
      top: 1563px;
      left: 697px;
      padding: 36px 193px;
      width: 549px;
      height: 199px;
      background: rgba(252, 252, 252, 0.39);
      border: 1px solid #1e7fb2;
      opacity: 1;
      border-radius: 57px;
      p {
        width: 163px;
        height: 128px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 32px;
        color: #333333;
      }
    }
    .platform {
      position: absolute;
      bottom: 0;
      left: 1253px;
      width: 484.16px;
      height: 484.16px;
      background: url(../../assets/images/7777.png);
      background-size: 484.16px 484.16px;
      p {
        position: absolute;
        top: 191px;
        left: 171px;
        width: 154px;
        height: 78px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 38px;
        color: #333333;
      }
    }
  }
  .answer {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 595px;
    background: url(../../assets/images/2222.png);
    background-size: 100% 595px;
    div {
      width: 575px;
      height: 66px;
      margin-top: 125px;
      margin-bottom: 70px;
      font-size: 50px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 61px;
      color: #333333;
      letter-spacing: 2px;
      opacity: 1;
    }
    p {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 85px;
      color: #333333;
      letter-spacing: 2px;
      opacity: 1;
    }
  }
}
</style>
